export const GitHubIcon = ({ size = 12 }: { size?: number }) => (
  <div
    style={{
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'inline-block',
      width: size,
      height: size,
    }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-label="GitHub"
      role="img"
      viewBox="0 0 512 512"
      width={size}
      height={size}>
      <path d="m0 0H512V512H0" fill="#181717" />
      <path
        fill="#fff"
        d="M335 499c-13 0-16-6-16-12l1-70c0-24-8-40-18-48 57-6 117-28 117-126 0-28-10-51-26-69 3-6 11-32-3-67 0 0-21-7-70 26-42-12-86-12-128 0-49-33-70-26-70-26-14 35-6 61-3 67-16 18-26 41-26 69 0 98 59 120 116 126-7 7-14 18-16 35-15 6-52 17-74-22 0 0-14-24-40-26 0 0-25 0-1 16 0 0 16 7 28 37 0 0 15 50 86 34l1 44c0 6-3 12-16 12-14 0-12 17-12 17H347s2-17-12-17Z"
      />
    </svg>
  </div>
);
